module.exports = __webpack_public_path__ + "media/images/header-bg3-ceece44d3b13207de371c089b9ee7de4.png";